import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BillingTab } from "./BillingTab";
import { PnlTab } from "./PnlTab";
import { WorkspaceCostsTab } from "./WorkspaceCostsTab";
import { PayoutsTab } from "./PayoutsTab";

const SUBS = ["billing", "pnl", "workspace-costs", "payouts"] as const;
type Sub = typeof SUBS[number];

export function FinancesTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const sub = (searchParams.get("sub") as Sub) || "billing";
  const value: Sub = SUBS.includes(sub) ? sub : "billing";

  const onChange = (v: string) => {
    setSearchParams((sp) => {
      sp.set("tab", "finances");
      sp.set("sub", v);
      return sp;
    });
  };

  return (
    <Tabs value={value} onValueChange={onChange}>
      <TabsList>
        <TabsTrigger value="billing">Billing</TabsTrigger>
        <TabsTrigger value="pnl">P&amp;L</TabsTrigger>
        <TabsTrigger value="workspace-costs">Workspace Costs</TabsTrigger>
        <TabsTrigger value="payouts">Payouts</TabsTrigger>
      </TabsList>
      <TabsContent value="billing" className="mt-4 space-y-4"><BillingTab /></TabsContent>
      <TabsContent value="pnl" className="mt-4 space-y-4"><PnlTab /></TabsContent>
      <TabsContent value="workspace-costs" className="mt-4 space-y-4"><WorkspaceCostsTab /></TabsContent>
      <TabsContent value="payouts" className="mt-4 space-y-4"><PayoutsTab /></TabsContent>
    </Tabs>
  );
}
